// Khung đọc thông báo cấp trên gửi — mở từ trang Thông báo, chuông (cả chuông khu /npp) và dải Tổng quan.
// Dùng Sheet như các khung chi tiết khác của web.

import { useRef } from 'react'
import type { QueryClient } from '@tanstack/react-query'
import { Sheet } from '@/components/ui/sheet'
import { AnnouncementView, type AnnouncementContent } from './AnnouncementView'

/** Đã đọc / ẩn một thông báo → chuông, trang Thông báo, dải Tổng quan cùng tải lại. */
export function refreshNotifications(qc: QueryClient) {
  for (const key of ['notifications-unread-count', 'notifications-recent', 'notifications-all', 'notifications-banners']) {
    void qc.invalidateQueries({ queryKey: [key] })
  }
}

export function AnnouncementSheet({ a, onClose }: { a: AnnouncementContent | null; onClose: () => void }) {
  // Giữ nội dung lúc khung đang trượt ra (a đã về null) — không chớp trống.
  const last = useRef<AnnouncementContent | null>(a)
  if (a) last.current = a
  const shown = a ?? last.current
  return (
    <Sheet open={!!a} onOpenChange={(v) => !v && onClose()} title={<span className="break-words">{shown?.title ?? ''}</span>} className="sm:max-w-lg">
      {shown && <AnnouncementView a={shown} hideTitle onLinkClick={onClose} />}
    </Sheet>
  )
}
